export default "__VITE_ASSET__BMhbj7ZN__"